const state = {
    filtersFacturacion: null
};
  
export default state;